/* Restore Source items after its optional overflow dropdown has run. */
(function () {
    const header = document.querySelector('.gh-navigation');
    const menu = header?.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!header || !menu || !nav || !window.MutationObserver) return;

    let restoring = false;

    const restoreAllItems = function () {
        if (restoring) return;
        const toggle = nav.querySelector('.gh-more-toggle');
        const dropdown = toggle?.querySelector('.gh-dropdown');
        if (!toggle || !dropdown) return;

        restoring = true;
        Array.from(dropdown.children).forEach(function (item) {
            nav.insertBefore(item, toggle);
        });
        toggle.remove();
        header.classList.remove('is-dropdown-open', 'is-dropdown-mega');
        header.classList.add('is-dropdown-disabled');
        restoring = false;
    };

    restoreAllItems();
    window.addEventListener('load', restoreAllItems);
    new MutationObserver(restoreAllItems).observe(nav, { childList: true });
})();
